<template>
  <button
    v-if="disableSendingDocumentation"
    title="Enviar documentação"
    @click="handleDocumentation()"
    class="btn btn-fill btn-icon btn-info"
  >
    <i class="ti-upload"></i>
  </button>

</template>
<script>
  import {mapActions} from 'vuex'

  export default {
    name: 'btn-ticket-documentation',

    props: {
      ticket: {
        required: true,
        type: Object
      },

      event: {
        required: true,
        type: Object
      }
    },

    computed: {
      disableSendingDocumentation () {
        if (!this.event) {
          return true
        } else if (this.event.winnerChoiceMode === 'ranking') {
          return !this.ticket.checkIn || !this.ticket.stockId || !this.ticket.winner
        } else {
          return this.ticket.winner && this.ticket.stockId
        }
      }
    },

    methods: {
      ...mapActions('tickets', ['resetOne']),

      handleDocumentation () {
        this.resetOne()
        this.$router.push({name: 'tickets.details', params: {id: this.ticket._id}})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Tickets/Actions/BtnOpenTicketDocumentation.vue